// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1vgE1","left":"InfoRow_left__1w06_"};